module.exports = __webpack_public_path__ + "static/media/standing-bw.ed041f88.jpg";